export const tokens = {
  rewardToken: {
    token: "ERP",
    address: "0x0a0e3bfD5a8cE610E735D4469Bc1b3b130402267",
    decimals: 18,
  },
};
